let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("ari8V")).then(() => parcelRequire('j4Pzu'));